import "./header.css"

import headerLogo from "../../../assets/general_assets/Transparent logo.png"
import { useEffect, useRef, useCallback } from "react"
import { scrollWithOffset } from "../scrollWithOffSet";
import { useNavigate, useLocation, Link } from "react-router-dom";

export default function Header() {

    const navigate = useNavigate()
    const location = useLocation()

    const headerRef = useRef(null);
    const headerImgRef = useRef(null);

    const responsiveMenu = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const body = document.body;


            if (window.scrollY > 50) {
                body.classList.add("scrolled")
                headerRef?.current.classList.add("fixedHeaderScrolled")
                headerImgRef?.current.classList.add("headerImgScrolled")

            } else {
                body.classList.remove("scrolled")
                headerRef?.current.classList.remove("fixedHeaderScrolled")
                headerImgRef?.current.classList.remove("headerImgScrolled")
            }

        };

        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    const showMenu = () => {
        responsiveMenu.current.style.animation = 'openMenu .3s ease forwards'

        const overlay = document.getElementById('overlay');
        if (overlay) overlay.classList.add('active');
        document.body.classList.add('click')
    }

    const hideMenu = () => {
        responsiveMenu.current.style.animation = 'closeMenu .3s ease forwards'

        const overlay = document.getElementById('overlay');

        if (overlay) overlay.classList.remove('active');
        document.body.classList.remove('click')
    }

    const clickCloseMenu = useCallback(() => {

        hideMenu();

    }, [hideMenu, responsiveMenu, headerRef]);

    useEffect(() => {
        if (!showMenu) return;

        window.addEventListener('touchmove', clickCloseMenu);

        return () => {
            window.removeEventListener('touchmove', clickCloseMenu);
        };

    }, [showMenu, clickCloseMenu]);

    const aboutUs = () => {
        const aboutUs = document.getElementById("aboutUs")
        hideMenu()
        scrollWithOffset(aboutUs, 100)
    }

    const events = () => {
        const events = document.getElementById("events")
        hideMenu()
        scrollWithOffset(events, 100)
    }

    const contato = () => {
        const footer = document.getElementById("footer")
        hideMenu()
        scrollWithOffset(footer, 0)
    }



    return (

        <>
            <header ref={headerRef}>
                <img ref={headerImgRef} alt="Nomadic Way" src={headerLogo} />

                <nav className="nav_options">
                    <ul>
                        <li onClick={() => {
                            if (location.pathname === "/" || location.pathname === "") {
                                aboutUs()
                            } else {
                                navigate("/", { state: { scrollTo: "aboutus" } })

                            }
                        }}>ABOUT US</li>
                        <li onClick={() => {
                            if (location.pathname === "/" || location.pathname === "") {
                                contato()
                            } else {
                                navigate("/", { state: { scrollTo: "contato" } })

                            }
                        }} style={{ borderLeft: "3px solid #fff", borderRight: "3px solid #fff", padding: "0px 20px 0px 20px" }}>CONTACTS</li>
                        <li onClick={() => {
                            if (location.pathname === "/" || location.pathname === "") {
                                events()
                            } else {
                                navigate("/", { state: { scrollTo: "events" } })

                            }
                        }}>EVENTS</li>
                    </ul>
                </nav>
                <button style={{ display: "none" }} className="buyButton">
                    Buy Tickets
                </button>

                <i onClick={showMenu} id="openHiddenMenu" class="bi bi-list"></i>
            </header>
            <nav ref={responsiveMenu} className="hidden_nav_options">
                <i onClick={hideMenu} id="closeHiddenMenu" class="bi bi-x-lg"></i>
                <ul>
                    <li onClick={() => {
                        if (location.pathname === "/" || location.pathname === "") {
                            aboutUs()
                        } else {
                            navigate("/", { state: { scrollTo: "aboutus" } })

                        }
                    }}>ABOUT US</li>
                    <li onClick={() => {
                        if (location.pathname === "/" || location.pathname === "") {
                            contato()
                        } else {
                            navigate("/", { state: { scrollTo: "contato" } })

                        }
                    }}>CONTACTS</li>
                    <li onClick={() => {
                        if (location.pathname === "/" || location.pathname === "") {
                            events()
                        } else {
                            navigate("/", { state: { scrollTo: "events" } })

                        }
                    }}>EVENTS</li>

                </ul>
            </nav>

        </>
    )
}